import {FormikContextType, useFormikContext} from 'formik';
import {CreatePlanFormProps} from './type';
import SponsorFormItem from '../SponsorFormItem';
import useGetInitialSponsorInformation from '../../../../services/hookService/sponsor/getInitialSponsorInformation/useGetInitialSponsorInformation';
import {initialValuesSponsorForm} from '../../CreateActivePlan/type';
import SingleInput from '../../../../components/formikFileds/SingleInput';
import SinglePriceInput from '../../../../components/formikFileds/SinglePriceInput';

const unit = 100000;
const CreatePlanForm = ({
  setIsShowMessageCountItems,
  setIsShowCategoryItems,
  setIsShowOptionalInformationPage,
  isEdit,
}: CreatePlanFormProps) => {
  const {sponsorInfo, isLoading} = useGetInitialSponsorInformation();
  const formikProps: FormikContextType<initialValuesSponsorForm> =
    useFormikContext();
  return (
    <div className="flex flex-col py-3 h-full text-md text-gray-800 overflow-y-scroll no-scrollbar">
      {/* start  item message count */}
      <SponsorFormItem
        isDisable={isEdit}
        isRequired={true}
        isShowArrowIcon={true}
        arrowHandler={() => setIsShowMessageCountItems(true)}
        title="تعداد پیام"
        value={formikProps?.values?.sponsering_package}
        removeValue={() => {
          formikProps.setFieldValue('sponsering_package', {
            title: '',
            id: null,
          });
          formikProps.setFieldValue('price', 0);
        }}
        isShowError={Boolean(
          !formikProps?.values.sponsering_package.title &&
            formikProps?.errors.sponsering_package?.title &&
            formikProps.touched.sponsering_package,
        )}
        error={formikProps.errors.sponsering_package?.title}
      />
      {/* start  item category */}
      <SponsorFormItem
        isDisable={isEdit}
        isRequired={true}
        isShowArrowIcon={true}
        arrowHandler={() => setIsShowCategoryItems(true)}
        title="دسته آگهی"
        value={formikProps.values.type}
        removeValue={() =>
          formikProps.setFieldValue('type', {title: '', id: null})
        }
        isShowError={Boolean(
          !formikProps.values.type.title &&
            formikProps.errors.type?.title &&
            formikProps.touched.type,
        )}
        error={formikProps.errors.type?.title}
      />
      {/* start  item text sponser */}
      <SponsorFormItem
        isShowArrowIcon={false}
        isRequired={true}
        title="متن تبلیغی مورد نظر"
        isShowError={Boolean(
          formikProps.errors.text && formikProps.touched.text,
        )}
        error={formikProps.errors.text}
      >
        <SingleInput
          name="text"
          placeholder="متن تبلیغی مورد نظرتان را بنویسید( حداکثر 60 حرف)"
          type="text"
          setValue={(value: string) => formikProps.setFieldValue('text', value)}
          value={formikProps.values.text ?? ''}
          label={''}
          onBlur={() => formikProps.setFieldTouched('text', true)}
        />
      </SponsorFormItem>
      {/* start  item link sponser */}
      <SponsorFormItem
        isShowArrowIcon={false}
        isRequired={true}
        title="لینک صفحه تبلیغی مورد نظر"
        isShowError={Boolean(
          formikProps.errors.link && formikProps.touched.link,
        )}
        error={formikProps.errors.link}
      >
        <SingleInput
          name="link"
          placeholder="لینک صفحه تبلیغی مورد نظرتان را بنویسید"
          type="text"
          setValue={(value: string) => formikProps.setFieldValue('link', value)}
          value={formikProps.values.link ?? ''}
          label={''}
          onBlur={() => formikProps.setFieldTouched('link', true)}
        />
      </SponsorFormItem>
      {/* start  item optional information */}
      <SponsorFormItem
        isDisable={false}
        isRequired={false}
        isShowArrowIcon={true}
        arrowHandler={() => setIsShowOptionalInformationPage(true)}
        title="اطلاعات اختیاری"
      ></SponsorFormItem>
      {/* start  item price */}
      <div className="flex flex-col items-start pt-3 px-8 ">
        <SinglePriceInput
          name="price"
          min={
            (!isLoading &&
              sponsorInfo &&
              sponsorInfo?.sponsering_package?.find(
                item => item.id === formikProps.values.sponsering_package.id,
              )?.minimum_bid_amount.payment_amount) ||
            0
          }
          value={formikProps?.values?.price ?? (0 as number)}
          isEdit={isEdit}
          label={''}
          placeholder={''}
          setValue={value => {
            formikProps.setFieldValue('price', value);
            formikProps.setFieldTouched('price', true);
          }}
          plusHandler={() => {
            if (!isEdit && formikProps.values.price) {
              formikProps.setFieldValue(
                'price',
                formikProps.values.price + unit,
              );
            }
          }}
          minusHandler={() => {
            if (!isEdit && formikProps.values.price) {
              formikProps.setFieldValue(
                'price',
                formikProps.values.price - unit,
              );
            }
          }}
        />
      </div>
      {/* end form items */}
    </div>
  );
};

export default CreatePlanForm;
